<template>
    <div class="sharedome">
         <vue-qr 
        :size="220"
        :margin="10"
        :auto-color="true"
        :dot-scale="1"
        :text="appSrc"
        
      />
    </div>
</template>

<script>
import VueQr from 'vue-qr'

export default {
    components: {
        VueQr
    },
    data(){
        return{
            appSrc:'yyy'
        }
    }
}
</script>
<style scoped>
.sharedome{
    width: 100%;
    height: 300px;
}
</style>